module.exports = __webpack_public_path__ + "img/world.1d9d101a.svg";